/* assets/cart-drawer.js
   Minimal AJAX cart drawer controls.
   - Adds item via /cart/add.js
   - Removes via /cart/change.js
   - Renders a simple template using response JSON
   - Ensure focus trap and aria handling
*/

(function(){
  // utilities
  function $(s, root=document) { return root.querySelector(s); }
  function $all(s, root=document) { return Array.from(root.querySelectorAll(s)); }
  const drawer = document.getElementById('cart-drawer');
  const panel = drawer && drawer.querySelector('.cart-drawer__panel');
  const itemsContainer = document.getElementById('cart-drawer-items');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
    // Focus management
    const focusEl = drawer.querySelector('.cart-drawer__close') || panel;
    focusEl.focus();
    trapFocus(drawer);
    fetchRenderCart();
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    releaseFocusTrap();
  }

  // Focus trap (simple)
  let lastFocused = null;
  function trapFocus(container){
    lastFocused = document.activeElement;
    const focusables = 'button, [href], input, textarea, select, [tabindex]:not([tabindex="-1"])';
    const nodes = Array.from(container.querySelectorAll(focusables));
    if (!nodes.length) return;
    const first = nodes[0], last = nodes[nodes.length-1];
    container.addEventListener('keydown', function(e){
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    container.dataset.trap = 'true';
  }
  function releaseFocusTrap(){
    const container = drawer;
    if (!container) return;
    container.removeEventListener('keydown', null);
    if (lastFocused) lastFocused.focus();
  }

  // Fetch cart and render basic list
  function fetchRenderCart(){
    fetch('/cart.js')
      .then(r => r.json())
      .then(renderCart)
      .catch(e => console.error('Cart fetch error', e));
  }

  function renderCart(cart){
    itemsContainer.innerHTML = '';
    if (!cart.items || !cart.items.length){
      const empty = document.createElement('div');
      empty.className = 'cart-drawer__empty';
      empty.textContent = themeTranslations.cart_empty || 'Your cart is empty';
      itemsContainer.appendChild(empty);
      subtotalEl.textContent = Shopify.formatMoney ? Shopify.formatMoney(cart.items_subtotal_price) : (cart.items_subtotal_price/100).toFixed(2);
      return;
    }

    cart.items.forEach(item => {
      const row = document.createElement('div');
      row.className = 'cart-drawer__item';
      row.innerHTML = `
        <img src="${item.image || '//images.unsplash.com/photo-1504215680853-026ed2a45def?w=200&auto=format'}" alt="${item.title}" class="cart-drawer__thumb" />
        <div class="cart-drawer__meta">
          <div class="cart-drawer__title">${item.product_title}</div>
          <div class="cart-drawer__variant">${item.variant_title || ''}</div>
          <div class="cart-drawer__qty">
            <button class="qty-decrease" data-line="${item.key}">−</button>
            <span>${item.quantity}</span>
            <button class="qty-increase" data-line="${item.key}">+</button>
          </div>
        </div>
        <div class="cart-drawer__price">${formatMoney(item.final_line_price)}</div>
      `;
      itemsContainer.appendChild(row);
    });
    subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    attachItemButtons();
  }

  function formatMoney(cents){
    // Try Shopify.formatMoney if present
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents);
    return (cents/100).toFixed(2);
  }

  // Attach quantity buttons (change via cart/change.js)
  function attachItemButtons(){
    itemsContainer.querySelectorAll('.qty-decrease').forEach(btn => {
      btn.addEventListener('click', e => {
        const key = e.currentTarget.dataset.line;
        changeLineQuantityByKey(key, -1);
      });
    });
    itemsContainer.querySelectorAll('.qty-increase').forEach(btn => {
      btn.addEventListener('click', e => {
        const key = e.currentTarget.dataset.line;
        changeLineQuantityByKey(key, 1);
      });
    });
  }

  // We need to map line key -> line index. Simplest approach: fetch cart, find item by key.
  function changeLineQuantityByKey(key, delta){
    fetch('/cart.js').then(r=>r.json()).then(cart=>{
      const idx = cart.items.findIndex(i => i.key === key);
      if (idx === -1) return;
      const newQty = Math.max(0, cart.items[idx].quantity + delta);
      updateLine(idx+1, newQty);
    });
  }

  function updateLine(line, qty){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(r=>r.json()).then(renderCart).catch(e => console.error(e));
  }

  // Add to cart API wrapper for forms with data-add-to-cart attribute
  function initAddToCartForms(){
    document.addEventListener('submit', function(e){
      const form = e.target;
      if (!form || !form.dataset || !form.dataset.ajaxAdd) return;
      e.preventDefault();
      const fd = new FormData(form);
      const body = {};
      // Convert to object expected by /cart/add.js (single item)
      for (let pair of fd.entries()){ // capture properties, id, quantity etc
        body[pair[0]] = pair[1];
      }
      // When adding multiple properties (like gift wrap), they should be named properties[Name]
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd
      }).then(r=>r.json()).then(item => {
        openDrawer();
        fetchRenderCart();
        // small visual confirmation if needed
      }).catch(err => console.error('Add to cart failed', err));
    }, {capture:false});
  }

  // Cart note form
  function initCartNoteForm(){
    const form = document.getElementById('cart-drawer-note-form');
    if (!form) return;
    form.addEventListener('submit', function(e){
      e.preventDefault();
      const note = form.querySelector('textarea[name="note"]').value || '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ note: note })
      }).then(r=>r.json()).then(cart => {
        // update UI
        // close? keep open
      }).catch(e=>console.error(e));
    });
  }

  // Open/close binding
  document.addEventListener('click', function(e){
    const openBtn = e.target.closest('[data-open-cart-drawer]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-action="close-drawer"]')) { e.preventDefault(); closeDrawer(); return; }
  });

  // Close on ESC
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Initialize
  document.addEventListener('DOMContentLoaded', function(){
    initAddToCartForms();
    initCartNoteForm();
    // Expose for debugging/testing
    window.themeCart = { openDrawer, closeDrawer, fetchRenderCart };
  });

})();
